import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { FinalizeStandDivisionAndFusionInputDto, FinalizeStandDivisionAndFusionOutputDto, StandDivisionAndFusionAdvanceValidationInputDto, StandDivisionAndFusionAreaMaintenanceValidationInputDto, StandDivisionAndFusionFusedStandAdvanceValidationInputDto, StandDivisionAndFusionFusedStandDetailDto, StandDivisionAndFusionFusedStandLookupDto, StandDivisionAndFusionFusedStandSearchInputDto, StandDivisionAndFusionFusedStandValidationInputDto, StandDivisionAndFusionStandDetailDto, StandDivisionAndFusionStandLookupDto, StandDivisionAndFusionStandSearchInputDto, StandDivisionAndFusionStandValidationInputDto } from '../dtos/stand-division-and-fusion/models';

@Injectable({
  providedIn: 'root',
})
export class StandDivisionAndFusionService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  ensureCanAdvance = (input: StandDivisionAndFusionAdvanceValidationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/orchestrator/planning/stand-division-and-fusions/advance-validation',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  ensureFusedStandCanAdvance = (input: StandDivisionAndFusionFusedStandAdvanceValidationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/orchestrator/planning/stand-division-and-fusions/fused-stands/advance-validation',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  finalize = (input: FinalizeStandDivisionAndFusionInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, FinalizeStandDivisionAndFusionOutputDto>({
      method: 'POST',
      url: '/api/orchestrator/planning/stand-division-and-fusions/finalize',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  searchFusedStands = (input: StandDivisionAndFusionFusedStandSearchInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandDivisionAndFusionFusedStandLookupDto>>({
      method: 'GET',
      url: '/api/orchestrator/planning/stand-division-and-fusions/fused-stands',
      params: { propertyId: input.propertyId, filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  searchStands = (input: StandDivisionAndFusionStandSearchInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandDivisionAndFusionStandLookupDto>>({
      method: 'GET',
      url: '/api/orchestrator/planning/stand-division-and-fusions/stands',
      params: { propertyId: input.propertyId, filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  validateAreaMaintenance = (input: StandDivisionAndFusionAreaMaintenanceValidationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/orchestrator/planning/stand-division-and-fusions/area-maintenance/validation',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  validateFusedStand = (input: StandDivisionAndFusionFusedStandValidationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandDivisionAndFusionFusedStandDetailDto>({
      method: 'POST',
      url: '/api/orchestrator/planning/stand-division-and-fusions/fused-stands/validation',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  validateStand = (input: StandDivisionAndFusionStandValidationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandDivisionAndFusionStandDetailDto>({
      method: 'POST',
      url: '/api/orchestrator/planning/stand-division-and-fusions/stands/validation',
      body: input,
    },
    { apiName: this.apiName,...config });
}